module.exports = __webpack_public_path__ + "img/main_4.2913a4db.jpg";